import { observable, runInAction, action, computed } from 'mobx'
import { get, json } from '../../../../utils/ajax'
import {objToValueObj, ValueObjToObj, setStore, handleSearchAndPage} from "../../../../utils/Utils"
import { message } from 'antd'
import moment from 'moment'

class BrandStore {
    @observable brandList //品牌列表
    @observable searchCondition //查询条件
    @observable pagination //品牌分页
    @observable brandLoading   //品牌加载loading
    @observable isShowEditModal //是否显示编辑模态框
    @observable editBrand   //保存当前编辑的品牌
    @observable brandInfo   //品牌编辑信息
    @observable editBrandData   //修改回显数据
    @observable editTitle   //根据不同的选择显示不同的模态框名
    @observable btnLoading

    constructor () {
        this.brandList = []
        this.searchCondition = {
            defaultName: ''
        }
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.brandLoading = false
        this.isShowEditModal = false
        this.editBrand = {}
        this.brandInfo = {
            icon: {},
            brandCode: {},
            foundingTime: {},
            defaultName: {},
            defaultDescription: {},
            enName: {},
            enDescribe: {}
        }
        this.editBrandData=[]
        this.editTitle = ''
        this.btnLoading = ''
    }

    /**
     * 选中的品牌列表
     */
    @computed
    get selectList () {
        return this.brandList.filter(item => item.checked)
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 获取品牌列表
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    getBrandList = async (page) => {
        this.brandLoading = true
        const params = handleSearchAndPage(page, this.pagination, this.searchCondition)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/brands:search`, params)
        runInAction(() => {
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.brandList = res.content || []
            this.brandLoading = false
        })
    }
    /**
     * 选中品牌
     * @param brand
     */
    @action
    selectBrand = (brand) => {
        let list = this.brandList.slice()
        const index = list.findIndex(item => item.id === brand.id)
        this.brandList[index].checked = !this.brandList[index].checked
    }
    /**
     * 批量切换品牌启用/停用
     * @param state 0 启用 1 停用
     * @returns {Promise.<void>}
     */
    @action
    toggleBrindStatus = async (state) => {
        const list = this.selectList.map(item => ({...item, state}))
        this.brandLoading = true
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/update/batch`, list)
        await this.getBrandList(this.pagination.current)
        message.success(state ? '启用成功' : '停用成功')
    }
    /**
     * 批量删除品牌
     */
    @action
    deleteBrands = async () => {
        const ids = this.selectList.map(item => item.id)
        await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/delete/batch`, ids)
        await this.getBrandList(this.pagination.current)
        message.success('删除成功')
    }
    /**
     * 搜索绑值
     * @param value
     */
    @action
    onSearchChange = (value) => {
        this.searchCondition = {
            defaultName: value
        }
    }
    /**
     * 打开编辑/新增模态框
     */
    @action
    openEditModal = async (editBrand = {}) => {
        this.isShowEditModal = true
        this.editBrand = editBrand
        this.clearBrandInfo()
        //编辑需要回显
        if (editBrand.id) {
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/get/${editBrand.id}`)
            runInAction(() => {
                this.editBrandData = Array.isArray(res)?res:[]
                res[0].foundingTime = res[0].foundingTime && moment(res[0].foundingTime)   //处理时间
                this.brandInfo = objToValueObj(res[0])
            })
        }
    }
    /**
     * 关闭编辑/新增模态框
     */
    @action
    closeEditModal = () => {
        this.isShowEditModal = false
    }
    /**
     * 编辑/新增模态确定
     */
    confirmEdit = async () => {
        if (this.editBrand.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/update/${this.editBrand.id}`, ValueObjToObj(this.brandInfo))    //修改
            res.status === 1 && message.success('修改成功')
        } else {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/add`, ValueObjToObj(this.brandInfo))    //新增
            res.status === 1 && message.success('新增成功')
        }
        this.closeEditModal()
        this.getBrandList(this.pagination.current)
    }
    /**
     * 品牌编辑框表单绑值
     * @param changedFields
     */
    @action
    onFieldsChange = (changedFields) => {
        this.brandInfo = {...this.brandInfo, ...changedFields}
    }
    /**
     * 清空品牌表单的值
     */
    @action
    clearBrandInfo = () => {
        let obj = {}
        for (let key of Object.keys(this.brandInfo)) {
            obj[key] = {}
        }
        this.brandInfo = obj
    }
    /**
     * 校验品牌代码是否重复
     * @param rule
     * @param value
     * @param callback
     */
    checkBrandCode = async (rule, value, callback) => {
        if (this.editBrand.id) {
            if(this.editBrandData[0].brandCode!==this.brandInfo.brandCode.value){
                const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/brands:search`, {
                    [`search.brandCode`]: value
                })
                let isBrandCode = res.content.find(i=>i.brandCode===value);
                if (isBrandCode) {
                    //编辑的时候不去校验
                    callback('品牌代码不能重复')
                }
                callback()
            }
        }else {
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/brands:search`, {
                [`search.brandCode`]: value
            })
            let isBrandCode = res.content.find(i=>i.brandCode===value);
            if (isBrandCode) {
                //编辑的时候不去校验
                callback('品牌代码不能重复')
            }
            callback()
        }

        callback()
    }
    /**
     * 校验品牌名是否重复
     * @param rule
     * @param value
     * @param callback
     */
    checkDefaultName = async (rule, value, callback) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/brands:search`, {
            [`search.defaultName`]: value
        })
        if (!this.editBrand.id && res.content && res.content.length) {
            callback('品牌名不能重复')
        }
        callback()
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.btnLoading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.btnLoading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.btnLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

}

export default new BrandStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/basicDataOfAutomobile/Brand/store.js